export default __webpack_public_path__ + "static/media/buger.b61ad709.jpg";